import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { AUTHENTICATION_CHANGE_VIEW_TYPE } from '../../constants/action_types';
import { EEventType } from '../../types/events';
export function changeView(view, data) {
  return function (dispatch, getState, context) {
    var _prevView$data;
    var _getState = getState(),
      prevView = _getState.view;
    var currentData = data;

    /**
     * @description В данном кейсе нам нужно достичь поведения, при котором,
     * если тип заголовка не поменялся из параметра data, то мы его сохраняем. Это нужно в поведении,
     * когда мы перешли на следующий тип отображения, а потом перешли на шаг назад,
     * у нас сохранялся альтернативный заголовок
     */
    if ((_prevView$data = prevView.data) !== null && _prevView$data !== void 0 && _prevView$data.headingType) {
      currentData = _objectSpread({
        headingType: prevView.data.headingType
      }, currentData);
    }
    dispatch({
      type: AUTHENTICATION_CHANGE_VIEW_TYPE,
      view: view,
      data: currentData
    });
    context.emitter.emit(EEventType.ViewChanged, {
      prevView: prevView.active,
      prevData: prevView.data,
      view: view,
      data: currentData
    });
  };
}